import Container from 'components/container/Container';
import Button from 'components/button/Button';
import {IPlan} from 'hooks/useStaticContent';
import usePortalLink from 'hooks/usePortalLink';
import Logout from '../logout/Logout';

const Manage = ({plan, name}: {plan?: IPlan; name?: string}) => {
  const {loading, openLink} = usePortalLink();

  return (
    <Container>
      <div>
        <h1 className="text-xl text-left font-bold">
          Hi{name ? ` ${name}` : ''},
        </h1>
        <p>
          <span className="text-md font-medium mb-2 inline-block">
            You are currently subscribed
            {plan ? (
              <>
                {' to the '}
                <span className="underline">
                  {plan.title.toLowerCase()}
                </span>{' '}
                plan
              </>
            ) : (
              ''
            )}
            .{' '}
          </span>
        </p>
        <Button
          disabled={loading}
          onClick={openLink}
          title={loading ? 'Loading...' : 'Manage subscription'}
        />
        <Logout className="rounded" />
      </div>
    </Container>
  );
};

export default Manage;
